export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline">About White Molar</div>
      <h1 className="font-display text-5xl tracking-tight mt-3 max-w-3xl">A curated marketplace for dentists who choose precision.</h1>
      <div className="grid lg:grid-cols-2 gap-12 mt-14 items-start">
        <div className="space-y-5 text-[var(--fm-text-2)] leading-relaxed">
          <p>White Molar was founded by clinicians and equipment specialists in India who were tired of compromises — between price and quality, between availability and trust. We are the authorised distributor for six of the world's most precise dental brands and we bring them to every Indian clinic with installation, training and warranty.</p>
          <p>From the loupes you wear during a root canal to the chair your patient reclines in, every product in our catalogue earns its place. We don't list what we wouldn't use ourselves.</p>
          <p>Our team operates from Mumbai with on-ground service partners in Delhi, Bengaluru, Chennai, Hyderabad and Kolkata.</p>
        </div>
        <div className="aspect-[4/5] overflow-hidden bg-[var(--fm-sage)]">
          <img src="https://images.unsplash.com/photo-1588776814546-daab30f310ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBkZW50aXN0JTIwd29ya2luZ3xlbnwwfHx8fDE3ODE1MTM2MzZ8MA&ixlib=rb-4.1.0&q=85" alt="Professional dentist" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
}
